import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";

import { getIcons } from "../store/actions";

export function useIconsData(props) {
  const { propertyId, icons = [], offset, limit, sortField, sortOrientation, searchText, hookEnabled = true } = props;

  const dispatch = useDispatch();
  const timer = useRef(null);

  const fetchIcons = (newOffset = offset, newLimit = limit) => {
    if (timer.current) {
      clearTimeout(timer.current);
    }

    timer.current = setTimeout(() => {
      const query = {
        sortField,
        sortOrientation,
      };

      if (newOffset || newLimit) {
        query.offset = icons.length ? newOffset : 0;
        query.limit = newLimit;
      }

      if (searchText) {
        query.searchText = searchText.trim().toLowerCase();
      }

      dispatch(getIcons(propertyId, query));
    }, 300);
  };

  useEffect(() => {
    if (hookEnabled) {
      fetchIcons();
    }
  }, [propertyId, sortField, sortOrientation, offset, limit, hookEnabled, searchText]);
}
